import React from "react"
import FeaturedContent from "./ui/FeaturedContent"
import RequestLink from "./RequestLink"

/**
 * Home Page Component
 * Displays the full-width layout for the homepage
 */
const HomePage = () => {
  return (
    <div className="w-full pt-6 md:pt-14 pb-[112px]">
      <FeaturedContent />

      {/* Request form link at bottom of page */}
      <div className="mt-8 md:mt-20 mx-auto">
        <RequestLink />
      </div>
    </div>
  )
}

export default HomePage
